module.exports = "/_next/static/images/dev-blog-illustration@2x_248bb570235856fe6509981bc24729f2.jpg";